import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";

firebase.initializeApp(
    {
        apiKey           : "AIzaSyCvfUnRB3Tr2X1mQBY-83VCUnJU3qXJzLU",
        authDomain       : "rr-production-cbc1f.firebaseapp.com",
        databaseURL      : "https://rr-production-cbc1f.firebaseio.com",
        projectId        : "rr-production-cbc1f",
        storageBucket    : "rr-production-cbc1f.appspot.com",
        messagingSenderId: "818638341180",
        appId            : "1:818638341180:web:750798d1a46f3ea1322f39",
        measurementId    : "G-W5HJWG4GVB"
    }
);
